import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ProtectedRoute = ({ allowedRoles, children }) => {
  const userRole = parseInt(sessionStorage.getItem("userRole"), 10);
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (!allowedRoles.includes(userRole)) {
      setShowPopup(true); // Show popup for all unauthorized roles
    }
  }, [userRole, allowedRoles]);

  const handleClosePopup = () => {
    setShowPopup(false);
    navigate(-1); // Redirect to home screen
  };

  return (
    <>
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 animate-fade-in">
          <div className="bg-white rounded-xl shadow-xl w-11/12 max-w-md p-6 text-center animate-slide-up">
            <h2 className="text-2xl font-bold text-red-600 mb-2">
              🚫 Access Denied
            </h2>
            <p className="text-gray-700 mb-6">
              Sorry, you don’t have permission to access this page.
            </p>
            <button
              className="bg-yellow-400 hover:bg-yellow-500 text-white font-semibold py-2 px-6 rounded-md transition duration-300"
              onClick={handleClosePopup}
            >
              Return
            </button>
          </div>
        </div>
      )}

      {allowedRoles.includes(userRole) && children}
    </>
  );
};

export default ProtectedRoute;
